import type {RerouterLocation, LocationType} from './types';

import * as React from 'react';

import {useHistory} from './hooks';
import {resolveLocation, stringifyLocation, partsMatch} from './utils';


export default function Link({
  to,
  className,
  activeClassName,
  onlyActiveOnIndex,
  children,
  handleExtension = false,
  ...props
}: {
  to?:
    | LocationType
    | ((arg1: RerouterLocation) => LocationType)
    | undefined
    | null;
  className?: string;
  activeClassName?: string;
  onlyActiveOnIndex?: boolean;
  onClick?:
    | ((arg1: React.MouseEvent<HTMLElement>) => unknown)
    | null
    | undefined;
  children?: React.ReactNode;
  target?: string | null | undefined;
  handleExtension?: boolean;
}) {
  const history = useHistory();
  const {location} = history;

  // @ts-expect-error - TS2345 - Argument of type '() => RerouterLocation' is not assignable to parameter of type 'RerouterLocation'.
  const nextLocation = to && resolveLocation(location, to);

  const isActive =
    nextLocation &&
    (onlyActiveOnIndex
      ? // @ts-expect-error - TS2339 - Property 'pathname' does not exist on type '() => RerouterLocation'.
        nextLocation.pathname === location.pathname
      : // @ts-expect-error - TS2339 - Property 'pathname' does not exist on type '() => RerouterLocation'.
        partsMatch(nextLocation.pathname, location.pathname));

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (props.onClick) {
      props.onClick(event);
    }

    if (event.isDefaultPrevented() || !nextLocation || props.target) {
      return;
    }

    if (!(event.ctrlKey || event.metaKey)) {
      event.preventDefault();
      if (handleExtension) {
        history.replace(nextLocation);
      } else {
        history.push(nextLocation);
      }
    }
  };

  if (!to) {
    return (
      // @ts-expect-error - TS2322 - Type '{ children: ReactNode; className: string | undefined; onClick?: ((arg1: MouseEvent<HTMLElement, MouseEvent>) => unknown) | null | undefined; target?: string | ... 1 more ... | undefined; }' is not assignable to type 'DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>'.
      <a {...props} className={className}>
        {children}
      </a>
    );
  }

  return (
    <a
      {...props}
      className={isActive && activeClassName ? activeClassName : className}
      onClick={handleClick}
      // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
      href={nextLocation && stringifyLocation(nextLocation)}
    >
      {children}
    </a>
  );
}
